import React from 'react'
import Label from './Label'
import ErrorMessage from './ErrorMessage'
import { useFieldsLocked } from '../../contexts/ReadOnlyContext'

export default function Textarea({
  error,
  label,
  name,
  onBlur,
  onChange,
  optional,
  tooltip,
  value,
  className,
  disabled: disabledProp,
  placeholder,
  rows,
  topMargin = 'mt-5',
  noLabelPadding,
}) {
  const fieldsLocked = useFieldsLocked()
  const disabled = disabledProp || fieldsLocked
  return (
    <div className={topMargin}>
      <Label label={label} tooltip={tooltip} noLabelPadding={noLabelPadding} />

      <div className="relative">
        <textarea
          className={`
            ${className ? className : 'rounded-lg px-4 w-full'}
            block
            resize-y
            bg-white dark:bg-rb-dark-mode
            text-rb-black dark:text-rb-dark-mode-text-light
            focus-visible:outline-0
            focus-visible:border-rb-green
            focus-visible:border-2
            focus:outline-0
            focus:border-2
            focus:border-rb-lite-grey
            focus:ring-transparent
            focus:ring-offset-transparent
            ring-transparent
            ring-offset-transparent
            border-1
            border-rb-lite-grey dark:border-rb-dark-mode-lighter
            placeholder-rb-mat-grey dark:placeholder-rb-dark-mode-text-grey
            ${disabled ? 'rb-disabled' : ''}
          `}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          placeholder={placeholder}
          rows={rows}
          disabled={disabled}
        />

        {optional && <p className="optional-text">Optional</p>}
      </div>

      <ErrorMessage text={error} />
    </div>
  )
}
